import { testimonials } from "@/mocks/comics";

export default function Story() {
  return (
    <section id="story" className="scroll-mt-20 bg-background-100/60 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mx-auto mb-10 max-w-2xl text-center">
          <p className="mb-2 inline-flex items-center justify-center gap-2 text-xs font-medium tracking-widest text-primary-700">
            <span className="h-px w-6 bg-primary-500"></span>
            读者口碑
            <span className="h-px w-6 bg-primary-500"></span>
          </p>
          <h2 className="text-2xl md:text-4xl">一起找回童年的人</h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
            从 70 后到 90 后，无数人在补档列表里重逢了旧时光。这些声音，是我们继续考古的动力。
          </p>
        </div>

        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {testimonials.map((t) => (
            <figure
              key={t.id}
              className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-5"
            >
              <div className="mb-3 flex items-center gap-1 text-primary-600">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-sm"></i>
                ))}
              </div>
              <blockquote className="flex-1 text-sm leading-relaxed text-foreground-700">
                “{t.text}”
              </blockquote>
              <figcaption className="mt-4 flex items-center gap-3 border-t border-background-200 pt-4">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-secondary-200 font-heading text-base text-secondary-900">
                  {t.name.charAt(0)}
                </span>
                <span>
                  <span className="block text-sm font-medium text-foreground-900">{t.name}</span>
                  <span className="block text-xs text-foreground-500">{t.role}</span>
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}